import React, { useState, useEffect } from "react";
import { Theme, useTheme } from '@mui/material/styles'
import { makeStyles } from "@mui/styles";
import {
  Button,
  Chip,
  FormControl,
  Grid,
  Input,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { getSalesOfficesAndRoutes } from "../../utils/GetPlanning";
import requestMissingContexts, { determineConfig, displayConfig } from "../../utils/GetContext";
import { useLocalStorage } from "../../componentUtils/LocalStorage";
interface Inputs {
    onSelectionChange: any;
  }
  interface HeaderState {
    isLoaded: boolean,
    deliveringPlants: string[],
    allDeliveringPlants: any,
    allRoutes: any,
    filteredRoutes: string[],
    customerStatus:any,
  }
  interface DeliveringPlant {
    deliveringPlant: string,
    name: string,
  }
  export default function ReportHeader(props: Inputs) {
    const [defaultSalesOffice, setDefaultSalesOffice] = useLocalStorage("SETTINGS.defaultSalesOffice", '');

    const theme: Theme = useTheme();
    const useStyles = makeStyles((theme: Theme) => ({
        cont: {
          marginTop: theme.spacing(3),
          marginBottom: theme.spacing(3),
        },
        grid: {
          marginLeft: theme.spacing(1),
        },
        load: {
          textAlign: "center",
          justify: "center",
        },
        chips: {
          display: 'flex',
          flexWrap: 'wrap',
        },
        chip: {
          margin: 2,
        },
        formControl: {
          minWidth: 200,
        },
      }));
      const classes = useStyles();
      const [checked, setChecked] = React.useState(true);
      const [state, setState] = useState<HeaderState>({
        isLoaded: false,
        deliveringPlants: defaultSalesOffice?[defaultSalesOffice]:[],
        allDeliveringPlants: [],
        allRoutes: [],
        filteredRoutes: [],
        customerStatus:'',
      });
      const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");

      useEffect(() => {
        if (state.isLoaded) return;
    
        getSalesOfficesAndRoutes(salesOrg.toString()).then(
          (v:any) => {
              //console.log(v?.plants)
            const r_so:any[] = v?.plants;
            if (r_so) {
              requestMissingContexts(["PLANTS"]).then((ctx) => {
                const contexts:any = ctx;
                var deliveringPlants: Array<DeliveringPlant> = [];
                for (var i=0; i<r_so.length; i++) {
                  const so = r_so[i].plant;
                  const desc = so + ": " + determineConfig(
                    contexts,
                    "PLANTS",
                    so || ""
                  );
                  const deliveringPlant:DeliveringPlant = {deliveringPlant: so, name: desc};
                  deliveringPlants.push(deliveringPlant);
                }
                setState({
                  ...state,
                  isLoaded: true,
                  allDeliveringPlants: deliveringPlants,
                });
              });
            }
          }
        )
      }, [state]);
      const handleSOChange = (event: any) => {
        let value = event.target.value;
        var filteredRoutes = new Map<string, boolean>();
        if (value) {
          // get all combined routes
          for(var i:number = 0; i<value.length; i++) {
            const rts = state.allRoutes.filter((elem: { salesOffice: any; }) => elem.salesOffice === value[i]);
            for(var j:number = 0; j<rts.length; j++) {
              filteredRoutes.set(rts[j].route, true);
            }
          }
        }
        const ftr = Array.from(filteredRoutes.keys());
        setState({...state, deliveringPlants: value, filteredRoutes: ftr});
      }
      const handleChange = (event: any) => {
        let value = 0;
        setChecked(event.target.checked);
        if (event.target.checked) {
          value = 1;
        }
        setState({...state, customerStatus: value});
      }
      const getStyles = (key: string, arr: string[]) => {
        return {
          fontWeight:
            arr.indexOf(key) === -1
              ? theme.typography.fontWeightRegular
              : theme.typography.fontWeightMedium,
        };
      }

      return (
        <Paper className={classes.cont}>
            <Grid className={classes.grid} container spacing={3}>
            <Grid item xs={8} md={8} lg={9}>
                <FormControl className={classes.formControl} fullWidth>
                <InputLabel id="select-multiple-so-label">Delivery Plant</InputLabel>
                    <Select
                    multiple
                    fullWidth
                    value={state.deliveringPlants || ""}
                    onChange={handleSOChange}
                    input={<Input id="select-multiple-so" />}
                    renderValue={(selected: any) => (
                        <div className={classes.chips}>
                        {selected.map((value: any) => (
                            <Chip key={value} label={value} className={classes.chip} />
                        ))}
                        </div>
                    )}
                    >
                    {state.allDeliveringPlants.map((option: any) => (
                        <MenuItem key={option.deliveringPlant} value={option.deliveringPlant} style={getStyles(option.deliveringPlant, state.allDeliveringPlants)}>
                        {option.name}
                        </MenuItem>
                    ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={2} md={2} lg={1}>
            <FormControl className={classes.formControl} fullWidth>
            
              <FormControlLabel
                      control={
                        <Checkbox
                          checked={checked}
                          onChange={handleChange}
                          color="primary"
                        />
                      }
                      label="Active Only"
                    />


            </FormControl>
            </Grid>
            <Grid item xs={2} md={2} lg={2}>
            <Button variant='outlined' onClick={() => props.onSelectionChange(state.deliveringPlants,state.customerStatus)}>Load Report Data</Button>

            </Grid>
            </Grid>
            
        </Paper>
      );
  }